export default __webpack_public_path__ + "static/media/boite3.aa447973.jpg";